enum WorkLocationEnum {
    HOME = 'home',
    OFFICE = 'office',
}

export default WorkLocationEnum;
